export const enum ButtonTypes {
  PRIMARY,
  SECONDARY,
  CANCEL,
  RESET,
  DEFAULT
}

// Shown in the header, footer and browser tab. public/index.html and
// public/manifest.json can't import this, so they repeat it.
export const SITE_NAME = "Music Collaboration Platform";

// Shared react-select styling so every dropdown (multiselect or single
// select) looks consistent. Without this, react-select's own default
// "selected option" highlight (a bold blue fill) only ever shows on a
// single-select like the active/archived filter — a multiselect hides an
// option entirely once it's selected (hideSelectedOptions defaults to
// isMulti), so its dropdown never shows that state and looks lighter.
// Applying the same option/menu colors everywhere removes that mismatch.
export const reactSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    borderRadius: 9999,
    minHeight: 44,
    borderColor: "#D9D9D9",
    borderWidth: state.isFocused ? 2 : 1,
    boxShadow: "none",
    "&:hover": { borderColor: "#D9D9D9" },
  }),
  // Above the project cards: their owner link and player sit at z-10 so
  // they stay clickable over the card link, and the open list went under them.
  menu: (base: any) => ({
    ...base,
    borderRadius: 8,
    overflow: "hidden",
    zIndex: 20,
  }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#E1EAF2"
      : state.isFocused
        ? "rgba(225, 234, 242, 0.5)" // #E1EAF2 at 50% opacity
        : "#ffffff",
    color: "#272727",
    cursor: "pointer",
  }),
};

// reactSelectStyles plus green pill chips, matching the instrument chips on
// cards and profiles. Used where instruments are picked (Edit Profile, Add /
// Edit project); the filter dropdowns keep the plain look.
export const instrumentChipSelectStyles = {
  ...reactSelectStyles,
  multiValue: (base: any) => ({ ...base, backgroundColor: "rgba(39, 63, 41, 0.07)", borderRadius: 9999 }),
  multiValueLabel: (base: any) => ({ ...base, color: "#273f29", fontWeight: 600, fontSize: 12, padding: "3px 2px 3px 10px", paddingLeft: 10 }),
  multiValueRemove: (base: any) => ({
    ...base,
    color: "#273f29",
    borderRadius: 9999,
    ":hover": { backgroundColor: "rgba(39, 63, 41, 0.12)", color: "#273f29" },
  }),
};

export const DEFAULT_AUTH_DATA = {
  access: "",
  refresh: "",
  id: 0,
  firstName: "",
  lastName: "",
  // avatar: "",
  username: "",
  email: "",
  // role: "",
};
